export default __webpack_public_path__ + "static/hellebuyck-7d6873ccc8a02fdab0bdbb7c7c35239c.jpg";